import React from 'react';
import { isBlank } from 'utils/helperMethods';
import { Box, Link } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import BidRequestPresenter from 'presenters/BidRequestPresenter';
import BidRequestValueField from './components/BidRequestValueField';

import useStyles from './useStyles';

const BidRequestInfo = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { bidRequest, chatParticipant } = props;

  const isCashOut = !isBlank(BidRequestPresenter.cashOutAmount(bidRequest));

  return (
    <Box className={classes.container}>
      <Box width="100%" display="flex" flexWrap="wrap">
        <BidRequestValueField
          label={t('models.App.BidRequest.buyerName')}
          value={BidRequestPresenter.buyerFullName(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.requestDate')}
          value={BidRequestPresenter.formatRequestDate(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.realtor')}
          value={BidRequestPresenter.realtor(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.location')}
          value={BidRequestPresenter.location(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.firstTime')}
          value={BidRequestPresenter.humanFirstTime(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.military')}
          value={BidRequestPresenter.humanHasMilitaryService(bidRequest)}
        />
        {BidRequestPresenter.isPurchase(bidRequest) && (
          <BidRequestValueField
            label={t('models.App.BidRequest.foundHome')}
            value={BidRequestPresenter.humanFoundHome(bidRequest)}
          />
        )}
        <Link href={`tel: ${BidRequestPresenter.phoneNumber(chatParticipant)}`}>
          <BidRequestValueField
            label={t('models.App.BidRequest.phone')}
            value={
              <NumberFormat
                displayType="text"
                format="+1 (###) ###-####"
                value={BidRequestPresenter.phoneNumber(chatParticipant)}
              />
            }
          />
        </Link>
        <Link href={`mailto:${BidRequestPresenter.email(chatParticipant)}`} target="_blank">
          <BidRequestValueField
            label={t('models.App.BidRequest.email')}
            value={BidRequestPresenter.email(chatParticipant)}
          />
        </Link>
      </Box>
      <Box className={classes.divider} my={2} />
      <Box width="100%" display="flex" flexWrap="wrap">
        <BidRequestValueField
          label={t('models.App.BidRequest.homeValue')}
          value={BidRequestPresenter.readablePriceTarget(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.mortgageLoanAmount')}
          value={BidRequestPresenter.readalbeLoanAmmount(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.targetLtv')}
          value={BidRequestPresenter.readableLtv(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.preferredTermYears')}
          value={BidRequestPresenter.preferredTerm(bidRequest)}
        />
        {isCashOut && (
          <BidRequestValueField
            label={t('models.App.BidRequest.cashOutAmount')}
            value={BidRequestPresenter.readalbeCashOutAmmount(bidRequest)}
          />
        )}
        <BidRequestValueField
          label={t('models.App.BidRequest.lockPeriod')}
          value={BidRequestPresenter.lockPeriodInDays()}
        />
      </Box>
      <Box className={classes.divider} my={2} />
      <Box width="100%" display="flex" flexWrap="wrap">
        <BidRequestValueField
          label={t('models.App.BidRequest.creditScoreEstimate')}
          value={BidRequestPresenter.creditScoreEstimate(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.annualPreTaxIncome')}
          value={BidRequestPresenter.readableAnnualPreTaxIncome(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.monthlyDebtPayment')}
          value={BidRequestPresenter.readableMonthlyDebtPayment(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.dtiEstimate')}
          value={BidRequestPresenter.readableDtiEstimate(bidRequest)}
        />
      </Box>
      <Box className={classes.divider} my={2} />
      <Box width="100%" display="flex" flexWrap="wrap">
        <BidRequestValueField
          label={t('models.App.BidRequest.purpose')}
          value={BidRequestPresenter.formatPurpose(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.occupancy')}
          value={BidRequestPresenter.formatOccupancy(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.propertyType')}
          value={BidRequestPresenter.formatPropertyType(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.hadBankrupt')}
          value={BidRequestPresenter.humanHadBankrupt(bidRequest)}
        />
        <BidRequestValueField
          label={t('models.App.BidRequest.hadForeclosure')}
          value={BidRequestPresenter.humanHadForeclosure(bidRequest)}
        />
      </Box>
      <Box className={classes.divider} my={2} />
    </Box>
  );
};

BidRequestInfo.propTypes = {
  bidRequest: BidRequestPresenter.shape().isRequired,
};

export default BidRequestInfo;



// WEBPACK FOOTER //
// ./src/sharedComponents/BidRequestInfo/BidRequestInfo.js